import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlyLettersDirective } from './only-letter.directive';
import { OnlyNumbersDirective } from './only-numbers.directive';
import { UppercaseTransformDirective } from './upper-case-transform.directive';
import { OnlyLettersDirectiveForm } from './form-only-letters.directive';
import { ThousandsSeparatorDirective } from './thousands-seperator';
import { LazyLoadBackgroundDirective } from './lazy-load-background.directive';
import { TooltipMCDTDirective } from './tooltip-mcdt/tooltip.directive';



@NgModule({
  declarations: [
    OnlyLettersDirective,
    OnlyNumbersDirective,
    UppercaseTransformDirective,
    TooltipMCDTDirective,
    OnlyLettersDirectiveForm,
    ThousandsSeparatorDirective,
    LazyLoadBackgroundDirective
  ],
  exports: [
    OnlyLettersDirective,
    OnlyNumbersDirective,
    UppercaseTransformDirective,
    OnlyLettersDirectiveForm,
    ThousandsSeparatorDirective,
    LazyLoadBackgroundDirective,
    TooltipMCDTDirective
  ],
  imports: [
    CommonModule,
  ]
})
export class DirectivesModule { }
